var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"HeaderType":_vm.headerType}}),_c('main',[_c('router-view',{on:{"headerType":_vm.HT}})],1),_c('Footer'),_c('ToTopButton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }